// ** Redux Imports
import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'
// ** Axios Imports
import axios from 'axios'
import { api } from '../../../../utility/constants'


// RateCutting LIST
export const RateCuttinglist = createAsyncThunk('RateCutting/RateCuttinglist', async (params) => {
  const response = await axios.post(`${api.api_url}/production/ratecutting/rateCuttingListJwt`, params)
  if (response && response.data && response.data.body && response.data.body.token) {
    params = {jwtToken:response.data.body.token}
    const response1 = await axios.post(`${api.api_url}/production/ratecutting/rateCuttingList`, params)
    if (response1 && response1.data && response1.data.body) {
    return {
      params,
      RateCuttingList: response1.data.body.RateCuttingArray,
      RateCuttingTotalList: response1.data.body.RateCuttingTotal
    }
   } else {
   } 
}
})
  // Master List
  export const MasterReportlist = createAsyncThunk('ItemWiseOrder/MasterReportlist', async (params) => {
    const response = await axios.post(`${api.api_url}/orderreport/reportMasterListjwt`, params)
    if (response && response.data && response.data.body && response.data.body.token) {
      params = {jwtToken:response.data.body.token}
      const response1 = await axios.post(`${api.api_url}/orderreport/reportMasterList`, params)
      if (response1 && response1.data && response1.data.body) { 
      return {  
        Design_Cutting_Lists: response1.data.body.job_cutting_design_code 
      }
     } else {
     } 
  }
  })
//saveData Api
export const saveData = createAsyncThunk('RateCutting/saveData', async params => {
  try {
  const response = await axios.post(`${api.api_url}/production/ratecutting/saveRateCuttingJwt`, params)
   if (response && response.data && response.data.body && response.data.body.token) {
   params = {jwtToken:response.data.body.token}
   const response1 = await axios.post(`${api.api_url}/production/ratecutting/saveRateCutting`, params)
   if (response1 && response1.data && response1.data.body) {
    return {
      statusFlag:response1.data.body && response1.data.body.statusFlag ? response1.data.body.statusFlag : 2,
      message:response1.data.body.message
    }
   }  else {
    return {
      statusFlag:response1.data.body ? response1.data.body.statusFlag : 2,
      message: response1.data.body ? response1.data.body.message : 'Server not reachable.Please try again later'
    }
   }
  } else {
    return {
      statusFlag:response.data.body ? response.data.body.statusFlag : 2,
      message: response.data.body ? response.data.body.message : 'Server not reachable.Please try again later'
    }
   }
  } catch (error) {
    return {
      statusFlag:2,
      message:'Server not reachable.Please try again later'
    }    
  }
})

//deleteData Api
export const deleteData = createAsyncThunk('RateCutting/deleteData', async params => { 
  const response = await axios.post(`${api.api_url}/production/ratecutting/deleteRateCuttingJwt`, params)  
  if (response && response.data && response.data.body && response.data.body.token) { 
    params = {jwtToken:response.data.body.token}
   const response1 = await axios.post(`${api.api_url}/production/ratecutting/deleteRateCutting`, params)
   if (response1 && response1.data && response1.data.body) { 
    return { 
      statusFlag:response1.data.body.statusFlag, 
      message:response1.data.body.message
    }
   }
  } else { 
    return {  
      statusFlag:response.data.statusFlag,
      message:response.data.message
    }
   }
})
export const RateCuttingSlice = createSlice({
  name: 'RateCutting',
  initialState: {
    data: [],
    total: 1,
    params: {},
    allData: [],
    RateCuttingList:[],
    RateCuttingTotalList: 0,
    statuslist:[],
    statusFlag:0,
    statuscode:0,
    Design_Cutting_Lists: []
  },
  reducers: {
    handleStatusFlag: (state, action) => {
      state.statusFlag = action.payload.statusFlag
    }
  },
  extraReducers: builder => {
    builder.addCase(saveData.fulfilled, (state, action) => {
      state.statusFlag = action.payload.statusFlag
      state.message = action.payload.message
    })
    .addCase(deleteData.fulfilled, (state, action) => {
      state.message = action.payload.message
     state.statusFlag = action.payload.statusFlag
    })
    .addCase(RateCuttinglist.fulfilled, (state, action) => {
      state.RateCuttingList = action.payload.RateCuttingList
      state.RateCuttingTotalList = action.payload.RateCuttingTotalList      
      state.params = action.payload.params
    })
    .addCase(MasterReportlist.fulfilled, (state, action) => {  
      state.Design_Cutting_Lists = action.payload.Design_Cutting_Lists 
    })
  }
})
export const {
  handleStatusFlag
} = RateCuttingSlice.actions
export default RateCuttingSlice.reducer
